import { Badge } from 'react-bootstrap';
import styles from './TicketStatusBadge.module.scss';

const TicketStatusBadgeComponent = ({ status, className = '' }) => {
  return (
    <div className={`${className} d-inline ${styles.statusBadge}`}>
      <Badge
        variant={(() => {
          if (status.closed) return 'success';
          if (status.code == 'NEW') return 'warning';
          return 'secondary';
        })()}
      >
        {status.label}
      </Badge>
    </div>
  );
};

export { TicketStatusBadgeComponent as TicketStatusBadge };
